module.exports = __webpack_public_path__ + "static/media/openengine-intro-video-bg.f3a57c81.svg";